import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import {
  EMAIL_NOTIFICATION_MUTATION,
  EMAIL_NOTIFICATION_PREFERENCE_QUERY,
} from '../../graphql';
import {
  EmailNotificationPreference,
  EmailNotificationPreferenceModel,
} from '../../models/email-notification.model';

@Injectable({ providedIn: 'root' })
export class EmailNotificationService {
  private clientName = APOLLO_CLIENT_NAMES.contact;

  constructor(private readonly apollo: Apollo) {}

  getEmailNotificationPreferences(): Observable<EmailNotificationPreferenceModel> {
    const fieldName =
      getQueryRootFieldName(EMAIL_NOTIFICATION_PREFERENCE_QUERY) ||
      'EmailNotifications';

    return this.apollo
      .use(this.clientName)
      .query({
        query: EMAIL_NOTIFICATION_PREFERENCE_QUERY,
        variables: {},
        fetchPolicy: 'no-cache',
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((result: any) => result.data.EmailNotifications),
      );
  }

  postEmailNotificationPreferences(
    emailNotificationPreferences: EmailNotificationPreference[],
  ): Observable<any> {
    const fieldName =
      getQueryRootFieldName(EMAIL_NOTIFICATION_MUTATION) ||
      'PostEmailNotificationPreferences';

    return this.apollo
      .use(this.clientName)
      .mutate({
        mutation: EMAIL_NOTIFICATION_MUTATION,
        variables: {
          emailNotificationPreferences,
        },
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((result: any) => result.data.PostEmailNotificationPreferences),
      );
  }
}
